import { renderRequiredRule } from "@/utils/renderRulesForm";

export default (applicationCargoPickup) => ({
  isCargoPickup: [],
  addressCargoPickup: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && value === "") {
          callback(new Error("Пожалуйста введите адрес"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  pickupDate: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && !value) {
          callback(new Error("Пожалуйста выберите дату"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],

  cargoStartTimePickup: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && value === "") {
          callback(new Error(""));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  cargoEndTimePickup: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.isCargoPickup && value === "") {
          callback(new Error(""));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  startTimeLunchBreak: [],
  endTimeLunchBreak: [],

  deliveryToTheAddress: false,
  addressConsignee: [renderRequiredRule("Пожалуйста введите адрес")],
  deliveryDate: [renderRequiredRule("Пожалуйста выберите дату")],

  cargoStartTimeDelivery: [renderRequiredRule("")],
  cargoEndTimeDelivery: [renderRequiredRule("")],
  startTimeLunchBreakDelivery: [],
  endTimeLunchBreakDelivery: [],

  dataOnTheDriver: [],
  comment: [],
});
